import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "car-search__dummy-listing dummy-listing"
}
const _hoisted_2 = {
  key: 2,
  class: "listing mpanel"
}
const _hoisted_3 = { class: "listing__figure listing-figure" }
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "listing-figure__image-counter"
}
const _hoisted_7 = { class: "listing__content" }
const _hoisted_8 = { class: "listing__header" }
const _hoisted_9 = { class: "listing__titles" }
const _hoisted_10 = { class: "listing__title" }
const _hoisted_11 = { class: "listing__sub-title" }
const _hoisted_12 = { class: "listing__price" }
const _hoisted_13 = { class: "listing__price--large" }
const _hoisted_14 = { class: "listing__price--large" }
const _hoisted_15 = {
  key: 2,
  class: "listing__price--large"
}
const _hoisted_16 = { class: "listing__specs" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { key: 8 }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = {
  class: "col-8 col-12-xs",
  style: {"align-self":"center"}
}
const _hoisted_28 = {
  key: 0,
  class: "listing__dealer"
}
const _hoisted_29 = { class: "listing__dealer-name" }
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "listing__distance"
}
const _hoisted_36 = {
  class: "col-4 col-12-xs",
  style: {"align-self":"flex-end"}
}
const _hoisted_37 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_finance_info = _resolveComponent("finance-info")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"dummy-listing__background dummy-listing__background--animated\"><div class=\"dummy-listing__wrap\"><div class=\"dummy-listing__left\"></div><div class=\"dummy-listing__right\"><div class=\"dummy-listing__space dummy-listing__space--title dummy-listing__space--left dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--title dummy-listing__space--right dummy-listing__masker\"></div><div class=\"clear\"></div><div class=\"dummy-listing__space dummy-listing__space--divider dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--left dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--right dummy-listing__masker\"></div><div class=\"clear\"></div><div class=\"dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--left dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--right dummy-listing__masker\"></div><div class=\"clear\"></div><div class=\"dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--left dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--right dummy-listing__space--double dummy-listing__masker\"></div><div class=\"clear\"></div><div class=\"dummy-listing__space dummy-listing__space--divider dummy-listing__space--divider-xs dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--left dummy-listing__masker\"></div><div class=\"dummy-listing__space dummy-listing__space--right dummy-listing__space--double dummy-listing__masker\"></div></div></div></div>", 1)
        ]))]))
      : _createCommentVNode("v-if", true),
    (!_ctx.loading && _ctx.initialLoad)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("v-if", true),
    (!_ctx.loading && !_ctx.initialLoad && _ctx.hasCurrentListing)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, [
          _createElementVNode("figure", _hoisted_3, [
            _createElementVNode("a", {
              href: _ctx.currentListing.vehicle.url,
              rel: "nofollow",
              target: _ctx.currentListing.vehicle.urlTarget,
              class: "listing__image--a"
            }, [
              _createElementVNode("img", {
                class: "listing-figure__image",
                src: _ctx.currentListing.vehicle.imageUrl,
                alt: (_ctx.offerType === 'used' && _ctx.currentListing.vehicle.registrationYear ? _ctx.currentListing.vehicle.registrationYear + ' ' : '' ) + _ctx.currentListing.vehicle.make + ' ' + _ctx.currentListing.vehicle.model
              }, null, 8 /* PROPS */, _hoisted_5),
              (_ctx.currentListing.vehicle.imageCount > 0 && _ctx.currentListing.paymentMethod === 'ppe')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fi-picture" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.currentListing.vehicle.imageCount) + " ", 1 /* TEXT */),
                    (_ctx.currentListing.vehicle.imageCount > 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" photos ")
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" photo ")
                        ], 64 /* STABLE_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.offerType === 'used')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "listing-figure__star",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleStarred && _ctx.toggleStarred(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fi-star listing-figure__star-icon", {'listing-figure__star-icon--active': _ctx.currentListingIsStarred}])
                    }, null, 2 /* CLASS */)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("header", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.currentListing.vehicle.make) + " " + _toDisplayString(_ctx.currentListing.vehicle.model), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.currentListing.vehicle.derivative), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.currentListing.vehicle.offerType === 'used' && _ctx.priceType === 'finance')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[3] || (_cache[3] = _createTextVNode(" From ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_13, " £" + _toDisplayString(_ctx.formatAmount(_ctx.currentListing.vehicle.monthlyPrice, 2)), 1 /* TEXT */),
                      _cache[4] || (_cache[4] = _createTextVNode(" p/m ", -1 /* CACHED */)),
                      (_ctx.currentListing.vehicle.pcpInfo || _ctx.currentListing.vehicle.hpInfo)
                        ? (_openBlock(), _createBlock(_component_finance_info, {
                            key: 0,
                            "pcp-info": _ctx.currentListing.vehicle.pcpInfo,
                            "hp-info": _ctx.currentListing.vehicle.hpInfo
                          }, null, 8 /* PROPS */, ["pcp-info", "hp-info"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_ctx.currentListing.vehicle.offerType === 'used' && _ctx.currentListing.vehicle.monthlyPrice)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_14, "£" + _toDisplayString(_ctx.formatAmount(_ctx.currentListing.vehicle.price, 0)), 1 /* TEXT */),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        (_ctx.currentListing.vehicle.pcpInfo || _ctx.currentListing.vehicle.hpInfo)
                          ? (_openBlock(), _createBlock(_component_finance_info, {
                              key: 0,
                              "pcp-info": _ctx.currentListing.vehicle.pcpInfo,
                              "hp-info": _ctx.currentListing.vehicle.hpInfo
                            }, {
                              default: _withCtx(() => [
                                _cache[5] || (_cache[5] = _createTextVNode(" or ", -1 /* CACHED */)),
                                _createElementVNode("span", null, "£" + _toDisplayString(_ctx.formatAmount(_ctx.currentListing.vehicle.monthlyPrice, 2)), 1 /* TEXT */),
                                _cache[6] || (_cache[6] = _createTextVNode(" p/m", -1 /* CACHED */))
                              ], undefined, true),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["pcp-info", "hp-info"]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "£" + _toDisplayString(_ctx.formatAmount(_ctx.currentListing.vehicle.price, 0)), 1 /* TEXT */)),
                (!_ctx.currentListing.vehicle.vatIncluded)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-grey-darkest text-xs" }, "excluding VAT", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("ul", _hoisted_16, [
              (_ctx.currentListing.vehicle.offerType === 'used' && _ctx.currentListing.vehicle.registrationYear)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_ctx.currentListing.vehicle.registrationYear), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.offerType === 'used' && _ctx.currentListing.vehicle.mileage > 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(_ctx.formatAmount(_ctx.currentListing.vehicle.mileage, 0)) + " miles ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.bodyStyle)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.currentListing.vehicle.bodyStyle)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.fuel)
                ? (_openBlock(), _createElementBlock("li", _hoisted_20, _toDisplayString(_ctx.currentListing.vehicle.fuel), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.transmission)
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, _toDisplayString(_ctx.currentListing.vehicle.transmission), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.offerType === 'new' && _ctx.currentListing.vehicle.mpg > 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, _toDisplayString(_ctx.currentListing.vehicle.mpg) + " MPG ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.roadTaxAmount)
                ? (_openBlock(), _createElementBlock("li", _hoisted_23, " £" + _toDisplayString(_ctx.currentListing.vehicle.roadTaxAmount) + " Road tax ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.ulezExempt)
                ? (_openBlock(), _createElementBlock("li", _hoisted_24, " ULEZ exempt "))
                : _createCommentVNode("v-if", true),
              (_ctx.currentListing.vehicle.wheelbase)
                ? (_openBlock(), _createElementBlock("li", _hoisted_25, _toDisplayString(_ctx.currentListing.vehicle.wheelbase), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                (_ctx.offerType === 'used')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("a", {
                          href: _ctx.dealerUrl,
                          target: "_blank"
                        }, _toDisplayString(_ctx.currentListing.dealer.company), 9 /* TEXT, PROPS */, _hoisted_30),
                        (_ctx.currentListing.dealer.rating > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                                return _createElementVNode("i", {
                                  class: _normalizeClass({'fi-star': true, 'star__basic': true, 'star__basic--full' : Math.round(_ctx.currentListing.dealer.rating) > n - 1})
                                }, null, 2 /* CLASS */)
                              }), 64 /* STABLE_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", null, [
                        (_ctx.currentListing.distance)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.currentListing.distance > 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fi-location text-navy" }, null, -1 /* CACHED */)),
                                    _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.currentListing.distance, 1)) + " miles away - ", 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              (_ctx.currentListing.distance <= 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fi-location text-navy" }, null, -1 /* CACHED */)),
                                    _cache[12] || (_cache[12] = _createTextVNode("within 1 mile - ", -1 /* CACHED */))
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("a", {
                          href: _ctx.dealerStockUrl,
                          rel: "nofollow"
                        }, "See all stock", 8 /* PROPS */, _hoisted_32)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fi-phone text-navy" }, null, -1 /* CACHED */)),
                        _createElementVNode("a", {
                          href: 'tel:' + _ctx.currentListing.dealer.telephone
                        }, _toDisplayString(_ctx.currentListing.dealer.telephone), 9 /* TEXT, PROPS */, _hoisted_33)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.offerType === 'used' && (_ctx.currentListing.dealer.thirtyOneDayCount || _ctx.currentListing.vehicle.thirtyOneDayCount))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fi-cog text-orange" }, null, -1 /* CACHED */)),
                      _createTextVNode(" " + _toDisplayString(_ctx.currentListing.vehicle.thirtyOneDayCount ?? 0) + " ", 1 /* TEXT */),
                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fi-user text-orange" }, null, -1 /* CACHED */)),
                      _createTextVNode(" " + _toDisplayString(_ctx.currentListing.dealer.thirtyOneDayCount ?? 0), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.offerType === 'new')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("i", { class: "fi-location text-navy" }, null, -1 /* CACHED */),
                      _createTextVNode(" National Delivery ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pb-10 d-none d-block-xs" }, null, -1 /* CACHED */)),
                _createElementVNode("a", {
                  href: _ctx.currentListing.vehicle.url,
                  rel: "nofollow",
                  target: _ctx.currentListing.vehicle.urlTarget,
                  class: "button button--ghost button--full button--small"
                }, " Go! ", 8 /* PROPS */, _hoisted_37)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}